import { render, staticRenderFns } from "./CallApp.vue?vue&type=template&id=d3257dee&scoped=true"
import script from "./CallApp.vue?vue&type=script&lang=js"
export * from "./CallApp.vue?vue&type=script&lang=js"
import style0 from "./CallApp.vue?vue&type=style&index=0&id=d3257dee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3257dee",
  null
  
)

export default component.exports